import { Box, Typography, CircularProgress } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { ReactElement, useLayoutEffect, useState } from 'react';
import {
    AppPrimaryButton,
    AppTeritaryButton,
} from 'shared/components/AppComponents';
import { TemplateService } from 'services';
import { Utils } from 'shared/helpers';

const ShareTemplateInvitation = (): ReactElement => {
    const navigate = useNavigate();
    const { templateId, tokendId } = useParams();
    const [isSubmitting, setSubmitting] = useState(false);
    const [inviteType, setInviteType] = useState('');
    const [isLoading, setLoading] = useState<boolean>(true);

    useLayoutEffect(() => {
        TemplateService.getShareTemplateInvitation({
            shareId: templateId ?? '',
            token: tokendId ?? '',
        })
            .then(() => {
                setLoading(false);
            })
            .catch((error) => {
                navigate(`/share-template/error`, {
                    state: error.response.data.msg,
                });
            });
    }, [navigate, templateId, tokendId]);

    // API Calls
    const onShareInvite = (inviteData: any, shareType: string): void => {
        setSubmitting(true);
        TemplateService.shareTemplateInvite(inviteData)
            .then((response: any) => {
                Utils.handleSuccessResponse(response);
                if (shareType === 'accept') {
                    navigate(`/share-template/accepted`);
                }
                if (shareType === 'reject') {
                    navigate(`/share-template/rejected`);
                }
            })
            .catch(() => {
                navigate(`/share-template/error`);
            })
            .finally(() => {
                setSubmitting(false);
            });
    };

    // UI Actions
    const actionOnShareTemplate = (shareType: string): void => {
        const requestPayload = {
            shareId: templateId,
            accept: shareType === 'accept',
            token: tokendId,
        };
        setInviteType(shareType);
        onShareInvite(requestPayload, shareType);
    };

    // UI Elements
    return (
        <Box className="share-template-invite-wrapper">
            {isLoading === false ? (
                <>
                    <Typography variant="h1" className="title">
                        Please accept/reject the custom dashboard template
                        shared with you.
                    </Typography>
                    <Box className="flex">
                        <AppPrimaryButton
                            title="Accept"
                            className="btn-small"
                            loadingText="ACCEPTING"
                            isLoading={
                                inviteType === 'accept' ? isSubmitting : false
                            }
                            onClick={() => actionOnShareTemplate('accept')}
                            disabled={isSubmitting}
                        />
                        <AppTeritaryButton
                            title="Reject"
                            className="btn-small ml-4"
                            loadingText="REJECTING"
                            isLoading={
                                inviteType === 'reject' ? isSubmitting : false
                            }
                            disabled={isSubmitting}
                            onClick={() => actionOnShareTemplate('reject')}
                        />
                    </Box>
                </>
            ) : (
                <CircularProgress
                    size={54}
                    color="inherit"
                    title="progress loading"
                />
            )}
        </Box>
    );
};

export default ShareTemplateInvitation;
